import { useEffect } from "react";

/**
 * Desktop scroll-wheel zoom. Bound natively (non-passive) so preventDefault
 * actually stops the page scrolling underneath the lightbox.
 */
export const useWheelZoom = (ref, { active, setZoom }) => {
  useEffect(() => {
    const el = ref.current;
    if (!el || !active) return;
    const onWheel = (e) => {
      e.preventDefault();
      const step = e.deltaY > 0 ? -0.25 : 0.25;
      setZoom((z) => Math.min(4, Math.max(1, Math.round((z + step) * 100) / 100)));
    };
    el.addEventListener("wheel", onWheel, { passive: false });
    return () => el.removeEventListener("wheel", onWheel);
  }, [ref, active, setZoom]);
};
